import { render } from "./LeaveModal.vue?vue&type=template&id=10a4667c&scoped=true"
import script from "./LeaveModal.vue?vue&type=script&lang=js"
export * from "./LeaveModal.vue?vue&type=script&lang=js"

import "./LeaveModal.vue?vue&type=style&index=0&id=10a4667c&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a4667c"]])

export default __exports__